import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import zhCN from "./locales/zh-CN.json";
import zhTW from "./locales/zh-TW.json";
import vi from "./locales/vi.json";
import th from "./locales/th.json";
import pt from "./locales/pt.json";
import ko from "./locales/ko.json";
import ja from "./locales/ja.json";
import id from "./locales/id.json";
import hi from "./locales/hi.json";

// 从 localStorage 获取保存的语言，默认繁体中文
const savedLanguage = localStorage.getItem("language") || "zh-TW";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    "zh-CN": { translation: zhCN },
    "zh-TW": { translation: zhTW },
    vi: { translation: vi },
    th: { translation: th },
    pt: { translation: pt },
    ko: { translation: ko },
    ja: { translation: ja },
    id: { translation: id },
    hi: { translation: hi },
  },
  lng: savedLanguage,
  fallbackLng: "zh-TW",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

// 监听语言变化，保存到 localStorage
i18n.on("languageChanged", lng => {
  localStorage.setItem("language", lng);
});

export default i18n;
